// @flow
export function sendAnalyticsEvent(event: Object) {
  // This is required for development and testing environments
  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  window.dataLayer.push(event);
}
